exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--preloader__3Y7bM{-webkit-box-flex:1;-ms-flex:1 1 1px;flex:1 1 1px;display:-webkit-box;display:-ms-flexbox;display:flex;height:40px;background:#c8d7e6 url(\"/public/images/_anti/preloader.gif\") no-repeat 50% 50%;background-size:32px 32px;position:relative;border-radius:20px}.styles--preloader__3Y7bM audio{display:none}.styles--preloader__3Y7bM .mejs__replay>button{background-position:0 0}\n", ""]);

// exports
exports.locals = {
	"preloader": "styles--preloader__3Y7bM"
};